import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

function UpcomingEventsSlick({ data }) {
    const settings = {
        dots: false,
        infinite: true,
        arrows: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1199.98,
                settings: {
                    slidesToShow: 3,
                    dots: true,
                    arrows: false,
                }
            },
            {
                breakpoint: 991, // tablet breakpoint
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 575, // mobile breakpoint
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    const handleClick = () => {
        window.scrollTo(0, 0);
    }

    const truncateDescription = (text = "") => {
        const words = text.split(" ");
        return words.length > 10 ? words.slice(0, 9).join(" ") + "..." : text;
    };

    return (
        <Slider {...settings}>
            {data.map((event) => (
                <div className="item" key={event.id}>
                    <figure>
                        <img src={event.image} alt={event.altText} width={338} height={190} loading="lazy" />
                    </figure>
                    <h3>{truncateDescription(event.title)}</h3>
                    <Link to={`/events${event?.button_url}`} className="button" onClick={handleClick}>
                        Know more
                    </Link>
                </div>
            ))}
        </Slider>
    );
}

export default UpcomingEventsSlick;
